import React from 'react';
import {Button, Flex, Grid, Modal, Typography} from 'antd';
import {big_reverse_logo, short_reverse_logo} from '../../Config/Images';
import {ListItemsInfoLinks} from '../ListItemsInfoLinks';
import {MenuOutlined} from '@ant-design/icons';
import {setContextIsSmallScreen} from '../../Context/LayoutProvider/LayoutProviderActions';
import {useLayoutDispatch, useLayoutState} from '../../Context/LayoutProvider/LayoutProvider';


interface ViewProps {
    title?: string,
    className?: string;
}

const {Title} = Typography;
const {useBreakpoint} = Grid;


export const ResponsiveHeader: React.FunctionComponent<ViewProps> = (props) => {
    const {title, className} = props;

    const [modalVisible, setModalVisible] = React.useState<boolean>(false);

    const screens = useBreakpoint();
    const {collapsed, isSmallScreen} = useLayoutState();
    const dispatch = useLayoutDispatch();

    const IMG = React.useMemo(() => {
        return (
            <img
                src={isSmallScreen ? short_reverse_logo : big_reverse_logo}
                alt="Diazar Logo"
                style={{height: 50}}
            />
        );
    }, [isSmallScreen]);

    const LIKS = React.useMemo(() => {
        if (isSmallScreen) return (
            <Button
                type="link"
                icon={<MenuOutlined/>}
                onClick={() => setModalVisible(prev => !prev)}
            />

        );
        return <ListItemsInfoLinks/>;
    }, [isSmallScreen]);

    const MODAL = React.useMemo(() => {
        if (!isSmallScreen) {
            return null;
        }

        return (
            <Modal
                open={modalVisible}
                footer={null}
                onCancel={() => setModalVisible(false)}
                centered
                title="Menu:"
            >

                <ListItemsInfoLinks isModal/>
            </Modal>
        );
    }, [isSmallScreen, modalVisible]);

    const TITLE = React.useMemo(() => {
        const level = isSmallScreen ? 3 : 2;
        return (
            <Title level={level} style={{margin: 0}}>{title}</Title>
        );
    }, [isSmallScreen, title]);

    React.useEffect(() => {
        const isSmall = !screens.lg;
        if(isSmallScreen === undefined || isSmall !== isSmallScreen){
            setContextIsSmallScreen(isSmall, dispatch);
        }
    }, [dispatch, collapsed, isSmallScreen, screens.lg]);

    return (
        <React.Fragment>
            <Flex className={ className } align="center" justify="space-between" style={{width: '100%'}}>
                {IMG}
                {TITLE}
                {LIKS}
            </Flex>
            {MODAL}
        </React.Fragment>
    );
};
